import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudService } from 'environments/crud.service';
import { file } from 'googleapis/build/src/apis/file';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-evaluaciones',
  templateUrl: './evaluaciones.component.html',
  styleUrls: ['./evaluaciones.component.css'],
  providers: [ CrudService ]
})
export class EvaluacionesComponent implements OnInit {
  token = sessionStorage.getItem('token')
  nombre = ""
  activa = false
  categorias_seleccionadas = []
  categorias = []
  puntos = []
  id

  constructor(
    private crud: CrudService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if ('id' in params) {
        this.id = params['id']
      }
      if(this.id){
        this.crud.getData('evaluacions/'+this.id, this.token).subscribe(
          response => {
            this.nombre = response.nombre
            this.activa = response.activa
            this.categorias_seleccionadas = response.categorias_seleccionadas
            this.puntos = response.puntos
          }
        )
      }
      this.crud.getData('categorias', this.token, {options:true}).subscribe(
        response => {
          let arr = []
          for (let dato of response.data) {
            arr.push({text:dato.nombre, value:dato.id})
          }
          this.categorias = [...arr]
        }
      )

    })
  }

  changeCategorias() {
    let datos = []
    let in_puntos = []
    let founds = []
    for (let cate of this.puntos){
      in_puntos.push(cate.value)
    }
    for (let punto of this.puntos){
      if (this.categorias_seleccionadas.includes(punto.value) && in_puntos.includes(punto.value)) {
        let dato = punto
        datos.push(dato)
        founds.push(punto.value)
  
      }

    }
    for (let categoria of this.categorias){
      if (this.categorias_seleccionadas.includes(categoria.value) && !founds.includes(categoria.value)){
        let dato = categoria
        dato['puntos'] = 0
        dato['sub_categorias'] = []
        this.crud.getData('sub_categorias', this.token, {options:true, id:categoria.value}).subscribe(
          response => {
            let subs = []
            for (let sub of response.data) {
              subs.push({text:sub.nombre, value:sub.id})
            }
            dato.sub_categorias = [...subs]
          }
        )
        dato['preguntas'] = [
          {
            pregunta:'',
            criterios:'',
            sub_categoria:0,
            puntos:0
          }
        ]
        datos.push(dato)
      }
    }
    this.puntos = datos
  }

  addPregunta(id){
    for (let punto of this.puntos){
      if (punto.value == id){
        let dato = {
            pregunta:'',
            criterios:'',
            sub_categoria:0,
            puntos:0,
            new:true,
        }
        punto.preguntas.push(dato)
      }
    }

  }
  deletePregunta(id, pregunta){
    
    for (let punto of this.puntos){
      if (punto.value == id){
        punto.preguntas.splice(pregunta, 1);
        // punto.preguntas.splice(pregunta, pregunta)
      }
    }

  }
  onSubmit(){
    let correcto = false
    let suma_categorias = 0
    for (let punto of this.puntos){
      console.log("punto", punto);
      let suma_puntos_preguntas = 0
      for (let pregunta of punto.preguntas){
        suma_puntos_preguntas += pregunta.puntos
        if (pregunta.pregunta == ""){
          Swal.fire('¡Oops!','El concepto "'+punto.text+'" tiene entregables en blanco')
          return false
          
        }
        if (pregunta.sub_categoria == 0 || pregunta.sub_categoria == ''){
          Swal.fire('¡Oops!','El concepto "'+punto.text+'" tiene entregables sin a evaluar', 'error')
          return false
          
        }
      }
      if (suma_puntos_preguntas != punto.puntos){
        Swal.fire('¡Oops!','La suma de los puntajes de los entregables del concepto "'+punto.text+'" no es igual a "'+ punto.puntos +'"', 'error')
        return false
        
      }
      if (punto.puntos == 0){
        Swal.fire('¡Oops!','Un concepto no puede tener puntaje 0', 'error')
        return false
        
      }
      suma_categorias += punto.puntos
      
    }
    if(suma_categorias != 100){
      Swal.fire('¡Oops!','La suma de los conceptos no es igual a 100', 'error')
      return false
    }
    if(!this.nombre){
      Swal.fire('¡Oops!','No puede existir una evaluacion sin nombre', 'error')
      return false
    }
    if(!this.puntos){
      Swal.fire('¡Oops!','No puede existir una evaluacion sin conceptos', 'error')
      return false
    }
    let data = {
      nombre:this.nombre,
      categorias_seleccionadas:this.categorias_seleccionadas,
      puntos:this.puntos,
      activo:this.activa,
    }
    if(this.id){
      this.crud.putData('evaluacions/'+this.id+'/',this.token, data).subscribe(
        response => {
          Swal.fire('¡Genial!', 'La evaluacion ha sido modificada correctamente', 'success')
          for(let punto of this.puntos){
            for(let pregunta of punto.preguntas){
              pregunta.new = false;
            }
          }
        },
        error => {
          let alert = ""
          for(let e in error.error){
            alert += e+": "+error.error[e]
          }
          Swal.fire('¡Oops!', alert, 'error');
        }
      )

    }
    else{
      this.crud.postData('evaluacions/',this.token, data).subscribe(
        response => {
          Swal.fire('¡Genial!', 'La evaluacion ha sido creada correctamente', 'success')
          setTimeout(() => {this.router.navigate(['/datos/evaluaciones'])}, 2000)
        },
        error => {
          let alert = ""
          for(let e in error.error){
            alert += e+": "+error.error[e]
          }
          Swal.fire('¡Oops!', alert, 'error');
        }
      )
    }
  }

}
